import React, { Fragment, useState, useEffect } from 'react';
import FacebookLogin from '@greatsumini/react-facebook-login';
import {
  Row,
  Card,
  CardBody,
  ModalFooter,
  Modal,
  ModalBody,
  Button,
  FormGroup,
  ButtonGroup,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  postAPI_Create_FacebookIntegration,
  postAPI_Create_FacebookIntegrationInGroupService,
  postAPI_Update_FacebookIntegration,
  gAPI_FBIngetration,
  gAPI_FBIntegrationByPropertyId,
  putAPI_Update_Ingetration_Group,
  dAPI_Delete_Ingetration_Group,
  dAPI_Delete_Ingetration,
} from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';
export default function IntegrationList({
  visible,
  toggle,
  propertyId,
  LoadIntegrations,
  allProperties,
}) {
  const [fbPages, setFbPages] = useState([]);
  const [fbUserData, setFbUserData] = useState({});
  const [access_token, setaccess_token] = useState('');
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const handleCheckChange = (e, index) => {
    const fbArray = [...fbPages];
    fbArray[index].pid = e.target.value;
    const fbproperties = [...fbPages[index].properties];
    fbproperties.map((elem) => {
      if (elem.id === e.target.value) {
        elem.checked = true;
      } else {
        elem.checked = false;
      }
      return elem;
    });

    setFbPages(fbArray);
  };

  const handleSave = () => {
    let whitelistData = {
      whitelisted_domains: [process.env.REACT_APP_BASE_CHATUI],
    };
    fbPages.map((page) => {
      let fields =
        'messages, messaging_postbacks, messaging_optins, \
                            message_deliveries, messaging_referrals';
      AxiosAPI({
        method: 'POST',
        url: `${process.env.REACT_APP_FB_GRAPH_API}${page.id}/subscribed_apps?access_token=${page.access_token}&subscribed_fields=${fields}`,
      }).then((susbscription) => {
        //console.log(susbscription.data)
      });

      //WHITE LIST
      AxiosAPI({
        method: 'POST',
        url: `${process.env.REACT_APP_FB_GRAPH_API}me/messenger_profile?access_token=${page.access_token}`,
        data: whitelistData,
      }).then((whitelist) => {
        console.log(whitelist.data);
      });

      //Get Page First to check for Editing
      AxiosAPI({
        method: 'get',
        url: `${gAPI_FBIngetration}?page_id=${page.id}`,
      }).then((res) => {
        let integrationRequest = {
          groupId: getGroupID(),
          name: 'Facebook Integration',
          propertyId: page.pid,
          sessionTimeoutInSeconds: 600,
          defaultLanguage: 'en-US',
          accessToken: fbUserData.accessToken,
          pageId: page.id,
          pageToken: page.access_token,
          pageName: page.name,
          userEmail: fbUserData.email,
          facebookId: fbUserData.userID,
          facebookName: fbUserData.name,
          BotSettings: {
            Name: 'Facebook Bob',
            Tagline: '',
            Colours: null,
            Text: null,
            Urls: null,
          },
        };

        if (res.data.pageId) {
          if (res.data.propertyId !== page.pid) {
            //Page Already used for another property
          } else {
            //pages.push(page.id)
            AxiosAPI({
              method: 'put',
              url: `${postAPI_Update_FacebookIntegration}/${res.data.integrationId
                }?group_id=${getGroupID()}`,
              data: integrationRequest,
            })
              .then((result) => {
                // console.log(result.data);
                LoadIntegrations();
              })
              .catch((err) => {
                console.log('err', err);
              });

            let forceRefresh = {
              updater: 'dashboard',
              refresh: true,
            };

            AxiosAPI({
              method: 'put',
              url: `${putAPI_Update_Ingetration_Group}/${res.data.id}`,
              data: forceRefresh,
            })
              .then((result) => {
                console.log(result.data);
              })
              .catch((err) => {
                console.log('err', err);
              });
          }
        } else {
          // pages.push(page.id)
          AxiosAPI({
            method: 'post',
            url: `${postAPI_Create_FacebookIntegration}`,
            data: integrationRequest,
          })
            .then((result) => {
              console.log(result.data);
              let groupFBRequest = {
                groupId: getGroupID(),
                propertyId: page.pid,
                integrationId: result.data.id,
                pageId: page.id,
                creator: 'dashboard',
              };
              AxiosAPI({
                method: 'post',
                url: `${postAPI_Create_FacebookIntegrationInGroupService}`,
                data: groupFBRequest,
              })
                .then((resultGroup) => {
                  // console.log(resultGroup.data);
                  LoadIntegrations();
                })
                .catch((err) => {
                  console.log('err', err);
                });
            })
            .catch((err) => {
              console.log('err', err);
            });
        }
      });
    });

    toggle();
    LoadIntegrations();
  };

  useEffect(() => { }, [fbPages]);

  const responseFacebook = (response) => {
    console.log("meta",response);
    if (response.accessToken && !response.error) {
      let accessToken = response.accessToken;
      let userID = response.userID;
      setFbUserData(response);

      const url = `${process.env.REACT_APP_FB_GRAPH_API}oauth/access_token?grant_type=fb_exchange_token&client_id=${process.env.REACT_APP_FB_APP_ID}&client_secret=${process.env.REACT_APP_FB_APP_SCRET}&fb_exchange_token=${accessToken}`;
      const options = {
        method: 'GET',
      };

      //Get All Pages for PropertyId
      AxiosAPI({
        method: 'get',
        url: `${gAPI_FBIntegrationByPropertyId}?property_id=${propertyId}`,
      }).then((propertyPagesRes) => {
        const propertyPages = propertyPagesRes.data;
        // Long Access Token
        fetch(url, options)
          .then((response) => response.json())
          .then((longResponse) => {
            accessToken = longResponse.access_token;
            setaccess_token(accessToken);
            AxiosAPI({
              method: 'get',
              url: `${process.env.REACT_APP_FB_GRAPH_API}${userID}/accounts?access_token=${accessToken}&fields=page,name,access_token`,
            }).then((res) => {
              if (res.data.data !== undefined && res.data.data.length > 0) {
                //   setFbPages(res.data.data);
                const pages = res.data.data.filter(
                  (m) => m.access_token !== undefined && m.access_token !== null
                );

                console.log(pages);
                setFbPages(
                  pages.map((elem) => {
                    console.log(elem);
                    elem.pid = propertyId;
                    const propertiesArray = allProperties.map((o) => ({
                      ...o,
                    }));
                    elem.properties = propertiesArray.map((p) => {
                      p.checked = false;
                      if (p.id === propertyId) {
                        p.checked = true;
                      }
                      return p;
                    });
                    return elem;
                  })
                );
              }
            });
          });
      });
    }
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalBody>
          <h6 className='mb-4'>To finish connecting your Facebook Messenger with the AI Chatbot, log In as admin of your business Facebook Page and continue to enable permissions.
          </h6>
          <Row className="mt-3">
            <Colxx xxs="6">
              <FacebookLogin
                appId={process.env.REACT_APP_FB_APP_ID}
                autoLoad={false}
                fields="name,email,picture"
                scope="pages_messaging,pages_manage_metadata,public_profile,pages_show_list,business_management"
               // callback={responseFacebook}
                onSuccess={responseFacebook}
  onFail={(error) => {
    console.log('Login Failed!', error);
  }}
  onProfileSuccess={(response) => {
    console.log('Get Profile Success!', response);
  }}
                render={(renderProps) => (
                  <button
                    onClick={renderProps.onClick}
                    style={{
                      backgroundColor: '#4267B2',
                      color: 'white',
                      padding: '16px 20px',
                      border: 'none',
                      // borderRadius: '4px',
                      fontSize: '14px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      textTransform: 'uppercase',
                      fontWeight: 'bold',
                    }}
                  >
                    Login with Facebook
                  </button>
                )}
              />
            </Colxx>
          </Row>
          <Row className="mt-4">
            {fbPages.map((page, pageindex) => {
              return (
                <Colxx xxs="6" key={pageindex}>
                  <h3>{page.name}</h3>
                  <FormGroup>
                    <div>
                      {page.properties.map((p, index) => {
                        return (
                          <CustomInput
                            key={`${page.id}_${p.id}`}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            checked={p.checked}
                            onChange={(event) =>
                              handleCheckChange(event, pageindex)
                            }
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Colxx>
              );
            })}
          </Row>
          {fbPages.length > 0 ? (
            <div className="text-center">
              <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                <Button color="primary" size="xs" onClick={handleSave}>
                  Create New Integration
                </Button>
                <Button size="xs" color="dark" outline onClick={toggle}>
                  Cancel
                </Button>
              </ButtonGroup>
            </div>
          ) : (
            ''
          )}
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment >
  );
}
